export default "__VITE_ASSET__CS0KXLfj__"